import { EmptyState } from "@hightouch/htui";
import searchPlaceholder from "src/assets/placeholders/search.svg";
import type { EmptyText } from "src/pages/ad-studio/insights/performance/view/types";

type CardsEmptyProps = { empty: EmptyText };

export const CardsEmpty = ({ empty }: CardsEmptyProps) => (
  <EmptyState
    variant="minimal"
    imageUrl={searchPlaceholder}
    title={empty.title}
    message={empty.message}
    my={8}
  />
);
